// A share of a whole, 0 to 1, as the browser's locale writes a percentage:
// French, among others, sets a space before the sign.
export const formatPercent = (share, maximumFractionDigits = 1) =>
  new Intl.NumberFormat(undefined, { style: 'percent', maximumFractionDigits }).format(share);
